export const BLOCKS_TYPES = Object.freeze({
  VIDEO_PRODUCTS: 'video_products',
  CATALOG: 'catalog',
  ARTICLES: 'articles',
  YOUTUBE: 'youtube',
  TEXT: 'text',
  IMAGE: 'image',
  COUNTERS: 'counter'
})

export const PRODUCTS_BLOCKS_TYPES = Object.freeze({
  FIXED: 'fixed',
  NOVELTY: 'novelty',
  SALE: 'sale',
  BUY_TOGETHER: 'buy_together',
  ESPUTNIK_RECOMENDATION: 'esputnik_recommendation',
  VIEWED_PRODUCTS: 'viewed_products'
})

export const ESPUTNIK_BLOCK_CONTEXT = Object.freeze({
  CONTEXT_PRODUCT: 'product',
  CONTEXT_CATEGORY: 'category',
  CONTEXT_CART: 'cart',
  CONTEXT_NO_CONTEXT: 'no_context'
})
